<template>
  <v-col :class="{ hiddenAtPrint: !selected && selectQrsToPrint }">
    <div style="page-break-inside: avoid;">
      <v-card
        class=" qrcode"
        outlined
        :style="
          'width:' +
            (size + 30) +
            'px; margin: auto auto auto auto;    border-radius: 20px;'
        "
      >
        <v-checkbox
          v-if="selectQrsToPrint"
          v-model="selected"
          class="hiddenAtPrint"
        />

        <v-card-title class="text-center title font-weight-bold text-center">
          {{ header }}
        </v-card-title>
        <v-row
          align="center"
          justify="center"
          :style="'width:' + size + 'px; margin: auto auto auto auto'"
        >
          <vue-qr
            :logoSrc="logo"
            :style="'width:' + size + 'px; margin: auto auto auto auto'"
            :text="qrUrl"
            :id="location.id"
            :size="600"
          />
        </v-row>
        <v-row align="center" justify="center">
          <v-card-subtitle class="text-center ">
            {{ subtitle }}</v-card-subtitle
          >
        </v-row>
        <v-row align="center" justify="center">
          <v-card-title class=" text-center fill-height " v-if="showName">
            {{ location.name }}
          </v-card-title>
        </v-row>
      </v-card>
    </div>
  </v-col>
</template>

<script>
import VueQr from "vue-qr";

export default {
  props: [
    "location",
    "logo",
    "index",
    "header",
    "subtitle",
    "showName",
    "size",
    "selectQrsToPrint"
  ],
  components: {
    VueQr
  },
  data() {
    return {
      selected: false
    };
  },

  computed: {
    qrUrl() {
      return this.location.codeId
        ? `https://bell.merlocode.com/${this.location.codeId}`
        : "https://i.giphy.com/media/RX3vhj311HKLe/giphy.webp";
    }
  }
};
</script>

<style></style>
